import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DataSpaceAttributeGroupDTO } from "../../api/sign-up/signup-api.types";

@Component({
  selector: "mh-admin-talent-data-spaces",
  templateUrl: "./admin-talent-data-spaces.component.html",
  styleUrls: ["./admin-talent-data-spaces.component.less"],
})
export class AdminTalentDataSpacesComponent {
  @Input() dataSpaceAttributes: Array<DataSpaceAttributeGroupDTO> = [];
  @Input() isCollapsed = false;
  @Output() toggle = new EventEmitter<void>();

  onToggle(): void {
    this.toggle.emit();
  }
}
